import send from '@/util/send';
import { ROOTPATH } from '@/config.js';
import _ from 'lodash';

async function tanslateApi(content, target = 'en') {
  const res = await send({
    url: ROOTPATH + '/app/aliyun/translate',
    method: 'POST',
    data: {
      formatType: 'json',
      sourceLanguage: 'zh',
      targetLanguage: target,
      sourceText: content,
    },
  });
  const { error, data, msg } = res.data;
  if (error === 0) {
    return data.Translated;
  } else {
    return Promise.reject(msg);
  }
}

async function translateChineseInDOM() {
  const chineseRegex = /[\u4e00-\u9fa5]+/g;
  const textNodes = [];
  const chineseTexts = [];

  // 第一步：收集所有包含中文的文本节点
  function collectChineseTextNodes(node) {
    if (
      node.nodeType === Node.ELEMENT_NODE &&
      node.tagName.toLowerCase() === 'script'
    ) {
      return; // 跳过 script 标签
    }
    if (node.nodeType === Node.TEXT_NODE) {
      const matches = node.nodeValue.match(chineseRegex);
      if (matches) {
        textNodes.push({ node, original: node.nodeValue });
        chineseTexts.push(node.nodeValue);
      }
    } else if (node.nodeType === Node.ELEMENT_NODE) {
      node.childNodes.forEach(collectChineseTextNodes);
    }
  }

  collectChineseTextNodes(document.body);

  // 第二步：调用翻译 API（你可以替换为自己服务端接口）
  async function translateTexts(texts) {
    return await tanslateApi(texts);
  }

  // 第三步：执行翻译
  const translatedTexts = await translateTexts(chineseTexts);

  // 第四步：回写翻译结果到 DOM
  textNodes.forEach(({ node }, index) => {
    node.nodeValue = translatedTexts[index];
  });
}

const outListenerUrlList = ['/app/aliyun/translate', 'api/v1/utm/event.gif', '/app/user/update-view'];

let currentTranlate = 'zh';

export function setTranlateLang(lang) {
  currentTranlate = lang;
}

export const debouncedTranslate = _.debounce(translateChineseInDOM, 300);


export async function translateListener(url) {
  if (currentTranlate === 'zh') {
    return;
  }
  if (outListenerUrlList.some((item) => url.indexOf(item) !== -1)) {
    return;
  }
  debouncedTranslate();
}
